import React from "react";
import { Flex, Avatar, Divider, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import CustomTitle from "../../components/CustomTitle";
import CustomParagraph from "../../components/CustomParagraph";
import CustomInput from "../../components/CustomInput";
import Img from "../../assets/images/default icon.png"
const SensorForm = ({
  getSensorImagePath,
  loading,
  searchQuery,
  sensorList,
  setSearchQuery,
  selectedSensor,
  setSelectedSensor,
  setModalOpen,
}) => {
  const filteredSensors = sensorList?.filter((provider) =>
    provider?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
  );


 const handleSelect = (provider) => {
  const updatedProvider = {
    ...provider,
    ...(provider?.description && {
      credential_description: provider.description,
    }),
  };

  // Remove original 'description' if it exists
  if (provider?.description) delete updatedProvider.description;

  setSelectedSensor(updatedProvider);
  setModalOpen(true);
};

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* <div
        style={{
          position: "sticky",
          top: 0,
          background: "#fff",
          zIndex: 10,
          paddingBottom: "10px",
        }}
      >
        <CustomTitle
          text="Add sensor"
          fontSize={24}
          fontWeight="700"
          color="#000"
          marginBottom="20px"
        />

        <CustomInput
          bgColor="#F3F3F3"
          height="36px"
          textColor="#000000"
          borderRadius="20px"
          border="none"
          placeholderColor="#5E5E5E"
          placeholder="Search for a sensor..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          prefix={
            <SearchOutlined
              style={{ color: "#000", fontSize: "12px", marginRight: "8px" }}
            />
          }
        />
      </div> */}
      <div
          style={{
            padding: "0px 32px",
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text="Add sensor"
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={"10px"}
          />
          <CustomInput
          width={'98%'}
          bgColor="#F3F3F3"
          height="36px"
          textColor="#000000"
           className="custom-input form-input-style"
          borderRadius="20px"
          border="none"
          placeholderColor="#5E5E5E"
          placeholder="Search for a sensor..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          prefix={
            <SearchOutlined
              style={{ color: "#000", fontSize: "12px", marginRight: "8px" }}
            />
          }
        />

        </div>

        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "130px",
            paddingTop: "62px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
        {loading ? (
          <Flex justify="center" align="center" style={{ height: "100%" }}>
            <Spin />
          </Flex>
        ) : filteredSensors?.length > 0 ? (
          <Flex
            wrap="wrap"
            style={{ justifyContent: "space-between" }}
          >
            {filteredSensors.map((provider, index) => {
  
              return (
                <React.Fragment key={provider.id}>
                  <Flex
                    align="center"
                    justify="space-between"
                    style={{
                      width: "48%",
                      padding: "6px 0px",
                      borderRadius: "8px",
                      // background: selectedSensor?.id === provider.id ? "#F5F5F5" : "#fff",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                    }}
                    className="custom-select"
                    onClick={() => handleSelect(provider)}
                  >
                    <Flex align="center" gap={10} style={{ marginLeft: "5px" }}>
                      <Avatar
                        size={34}
                        src={
                          <img
                            src={getSensorImagePath(provider.name, 'SensorImages')}
                            alt="avatar"
                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                          />
                        }
                        style={{
                          backgroundColor: getSensorImagePath(provider.name, 'SensorImages') ? "transparent" : "#d9d9d9",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#555",
                        }}
                      >
                        {!getSensorImagePath(provider.name, 'SensorImages') && provider.name.charAt(0)}
                      </Avatar>
                      <CustomParagraph
                        marginBottom={"0px"}
                        text={provider.name}
                        fontSize={12}
                        fontWeight={600}
                      />
                    </Flex>
                  </Flex>

                  {(index + 1) % 2 === 0 && (
                    <Divider style={{ width: "100%", margin: "5px 0" }} />
                  )}
                </React.Fragment>
              );
            })}
          </Flex>
        ) : (
          <Flex justify="center" align="center" style={{ height: "100%" }}>
            <CustomParagraph text="No sensors available" fontSize={14} />
          </Flex>
        )}
      </div>
    </div>
  );
};

export default SensorForm;
